import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { Footer } from "@/components/Footer";

const AUTH_IMG = "https://images.pexels.com/photos/950241/pexels-photo-950241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Signup() {
  const navigate = useNavigate();
  const [businessName, setBusinessName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/signup", { business_name: businessName, name, email, password });
      window.location.href = "/dashboard";
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 relative pb-12" data-testid="signup-page">
      <div className="flex items-center justify-center px-6 py-12 bg-white">
        <div className="w-full max-w-sm fade-up">
          <div className="overline mb-3">Start free</div>
          <h1 className="font-display text-4xl font-bold tracking-tighter text-[#0F172A] mb-2">Open your ledger.</h1>
          <p className="text-sm text-[#6B7280] mb-10">Create your business workspace in 30 seconds. Your data is private to your business.</p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="signup-form">
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-wider text-[#4B5563] font-semibold">Business Name</Label>
              <Input value={businessName} onChange={(e) => setBusinessName(e.target.value)} required
                data-testid="signup-business-input" placeholder="e.g. Acme Traders"
                className="rounded-none border-[#E5E7EB] focus-visible:ring-0 focus-visible:border-[#0F172A] h-11" />
            </div>
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-wider text-[#4B5563] font-semibold">Your Name</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} required
                data-testid="signup-name-input"
                className="rounded-none border-[#E5E7EB] focus-visible:ring-0 focus-visible:border-[#0F172A] h-11" />
            </div>
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-wider text-[#4B5563] font-semibold">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="signup-email-input" autoComplete="email"
                className="rounded-none border-[#E5E7EB] focus-visible:ring-0 focus-visible:border-[#0F172A] h-11" />
            </div>
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-wider text-[#4B5563] font-semibold">Password</Label>
              <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
                autoComplete="new-password" testid="signup-password-input"
                placeholder="min 6 characters"
                className="rounded-none border-[#E5E7EB] focus-visible:ring-0 focus-visible:border-[#0F172A] h-11" />
            </div>
            {error && <div className="text-xs text-[#EF4444]" data-testid="signup-error">{error}</div>}
            <Button type="submit" disabled={loading} data-testid="signup-submit-button"
              className="w-full h-11 rounded-none bg-[#0F172A] hover:bg-[#1E293B] text-white text-sm font-semibold uppercase tracking-wider">
              {loading ? "Creating workspace…" : "Create my workspace"}
            </Button>
          </form>

          <div className="mt-8 text-xs text-[#6B7280]">
            Already have an account?{" "}
            <Link to="/login" className="text-[#0F172A] font-semibold border-b border-[#0F172A]" data-testid="goto-login">
              Sign in
            </Link>
          </div>
        </div>
      </div>
      <div className="relative hidden lg:block">
        <img src={AUTH_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0F172A]/40" />
        <div className="absolute inset-0 flex flex-col justify-end p-12 text-white">
          <div className="overline text-white/70 mb-3">PKR · Cash Flow · Ledger</div>
          <h2 className="font-display text-5xl font-bold leading-tight tracking-tighter max-w-md">
            One workspace per business. Total privacy.
          </h2>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 bg-white">
        <Footer />
      </div>
    </div>
  );
}
